var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramBot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 238308"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40497",
    width: 48,
    height: 48,
    rx: 10,
    fill: "#00A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.7189 25.281L27.6228 20.3771M32.6393 17.3844L28.4999 30.8373C28.1288 32.0433 27.9434 32.6463 27.6234 32.8463C27.3458 33.0197 27.0019 33.0481 26.6996 32.9227C26.3511 32.7781 26.0686 32.2138 25.5043 31.0852L22.8825 25.8416C22.7929 25.6625 22.7481 25.573 22.6883 25.4954C22.6352 25.4265 22.5738 25.3647 22.5049 25.3117C22.4273 25.2518 22.3375 25.2071 22.1584 25.1175L16.9148 22.4957C15.7862 21.9314 15.2218 21.6494 15.0772 21.3009C14.9518 20.9986 14.9804 20.6543 15.1538 20.3767C15.3538 20.0567 15.9568 19.8713 17.1628 19.5002L30.6158 15.3608C31.5639 15.0691 32.0378 14.9232 32.3581 15.0408C32.637 15.1432 32.8571 15.363 32.9595 15.642C33.077 15.9622 32.931 16.4363 32.6393 17.3844Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramBot);
export default __webpack_public_path__ + "static/media/TelegramBot.c3158b2a1b8cf5ae4a0f90c50aa3aacd.svg";
export { ForwardRef as ReactComponent };